import { Navigate, useNavigate } from "react-router-dom";
import { HiArrowLeft } from "react-icons/hi2";
import CredentialsForm from "../components/CredentialsForm";
import Layout from "../components/layout/Layout";
import { useCurrentUser } from "../hooks/useCurrentUser";

export default function ConnectExchange() {
  const { status: authStatus, user } = useCurrentUser();
  const navigate = useNavigate();

  if (authStatus === "loading") {
    return <div className="min-h-screen flex items-center justify-center text-sm text-[#697077]">Loading…</div>;
  }
  if (authStatus === "anonymous") return <Navigate to="/login" replace />;

  return (
    <Layout user={user}>
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex items-center gap-1.5 text-sm font-medium text-[#697077] hover:text-[#21272A] mb-4"
      >
        <HiArrowLeft className="w-4 h-4" /> Back
      </button>

      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 max-w-lg mx-auto">
        <h2 className="text-sm font-semibold text-[#21272A] mb-4">Connect To Your Exchange Securely</h2>
        <CredentialsForm onSaved={() => navigate(-1)} />
      </div>
    </Layout>
  );
}
